export default __webpack_public_path__ + "static/media/Deshbandhu.e60edeb3.jpg";